import { ExtranetPackStatus } from 'app/typings/core/extranet/hotel/packs';

// A pack in SETUP is visible in the extranet so the hotel can fill in its
// ventilation, but it is not on sale yet. An UNPUBLISHED pack is hidden from
// the extranet altogether.
export const EXTRANET_VISIBLE_PACK_STATUSES = [
  ExtranetPackStatus.PUBLISHED,
  ExtranetPackStatus.SETUP,
];

export const isPackVisibleInExtranet = (status: ExtranetPackStatus) =>
  EXTRANET_VISIBLE_PACK_STATUSES.includes(status);

export const isPackInSetup = (status: ExtranetPackStatus) =>
  status === ExtranetPackStatus.SETUP;

export function getNewExtranetUrl(hotelId: number): string {
  const params = new URLSearchParams(window.location.search);

  params.delete('hotelId');
  params.append('hotelId', hotelId.toFixed(0));

  return (
    window.location.origin + window.location.pathname + '?' + params.toString()
  );
}
